export const privacyPolicyList = {
  whitePad: {
    name: "WhitePad",
    policies: [
      "We don't collect/sell user personal data.",
      "We may collect only user email address just to authenticate user.",
      "We don't collect any sensitive information like user age, gender, password or similar others.",
      "We may ask for storage permission just to save the generated images within our apps.",
      "We don't steal users data from storage.",
      "We don't collect images/drawings generated by user in our app.",
    ],
  },
};

export const privacyPolicyEmail = "apkstore800@gmail.com";
